import { defineStyle } from '@chakra-ui/react';

export const transparentVariant = defineStyle({
  base: {
    backgroundColor: 'transparent',
    color: 'neutral.300',
    border: 'none',
  },
  _hover: {
    color: 'skyBlue',
  },
  '&[data-active=true]': {
    color: 'skyBlue',
  },
  _disabled: {
    cursor: 'default',
  },
});
